<template>
    <div class="row clearfix">
        <div v-if="loading" class="loading"></div>
        <!-- <div v-if="messageStatus" class="alert alert-success" role="alert">
            {{ messageStatus }}
        </div> -->
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="">
                <div class="header">
                    <h2>Технические неполадки</h2>
                </div>
                <div class="body">
                    <table class="table table-bordered table-striped js-table dataTable order-table">
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>Страница</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in items">
                            <td>{{ item.id }}</td>
                            <td>{{ item.selected }}</td>
                            <td>
                                <b-form-checkbox v-model="item.checked" name="check-button" @change="changeTech(item)" switch>
                                    Включить
                                </b-form-checkbox>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AdminTechIssues",
        data() {
            return {
                loading: false,
                items: [],
            }
        },

        mounted() {
            this.loading = true

            this.axios
                .get(this.axios.defaults.baseURL + 'admin/tech-issues')
                .then(response => {
                    response.data.issues.forEach(function(entry) {
                        if(entry.hasOwnProperty("checked"))
                            entry.checked = !!+entry.checked
                    });
                    this.items = response.data.issues
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false
            })
        },

        methods: {
            changeTech(item) {
                this.loading = true

                this.axios
                    .post(this.axios.defaults.baseURL + 'admin/tech-issues/' + item.id, {
                        'checked': '' + item.checked + ''
                    })
                    .then(response => {
                        // this.items = response.data.issues;
                        console.log(response.data.message)
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                        this.loading = false
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/admin/tech/index.vue